import React, { ReactElement } from 'react';

import { Dropdown, DropdownOption } from '../Dropdown';

import { createValueChangeHandler } from './helpers/createValueChangeHandler';
import { deriveDurationResponseOptions } from './helpers/deriveDurationResponseOptions';
import { findSelectedOption } from './helpers/findSelectedOption';
import { formatDurationDisplayText } from './helpers/formatDurationDisplayText';
import { valueToDropdownItem } from './helpers/valueToDropdownItem';

export type DropdownDurationPickerProps = {
  min?: number;
  max?: number;
  selectedValue?: number | '';
  onValueChange?: (value: number | null) => void;
  highlight?: boolean;
  hideEmptyOption?: boolean;
};
const DropdownDurationPicker = ({
  min,
  max,
  selectedValue,
  onValueChange,
  highlight,
  hideEmptyOption,
}: DropdownDurationPickerProps): ReactElement => {
  const options = deriveDurationResponseOptions({ min, max });
  const selectedOption = findSelectedOption({ options, selectedValue });
  const selectedOptionAsDropdownItem = valueToDropdownItem(selectedOption);

  return (
    <Dropdown
      hideEmptyOption={hideEmptyOption}
      value={selectedOptionAsDropdownItem}
      onValueChange={createValueChangeHandler(onValueChange)}
      highlight={highlight}
    >
      {options.map(val => (
        <DropdownOption
          key={`${val}`}
          value={`${val}`}
          displayText={formatDurationDisplayText(val)}
        />
      ))}
    </Dropdown>
  );
};
export { DropdownDurationPicker };
